import { render } from "./PaymentDelivery.vue?vue&type=template&id=6252761d&scoped=true"
const script = {}

import "./PaymentDelivery.vue?vue&type=style&index=0&id=6252761d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6252761d"

export default script